import "./App.css";
import Home from "./Component/Home";
import LiquidDropLogin from "./Component/LiquidDropLogin";
import {
  HashRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Cookies from "js-cookie";
import Main from "./Component/Main";
import Users from "./Component/Users";
import Emails from "./Component/Emails";
import Proxy from "./Component/Proxy";
import Files from "./Component/Files";
import Whitelist from "./Component/Whitelist";
import UserFile from "./Component/UserFile";

// 创建一个受保护的路由组件
const ProtectedRoute = ({ children }) => {
  // 使用cookie检查登录状态
  const isAuthenticated = !!Cookies.get("token");

  if (!isAuthenticated) {
    // 如果未登录，重定向到登录页面
    return <Navigate to="/" replace />;
  }

  return children;
};

function App() {
  return (
    <Router>
      <Routes>
        {/* 登录页面路由 */}
        <Route path="/" element={<LiquidDropLogin />} />

        {/* Home路由，包含所有需要登录才能访问的页面 */}
        <Route
          path="/Home"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/Home/main" replace />} />
          <Route path="main" element={<Main />} />
          <Route path="users" element={<Users />} />
          <Route path="emails" element={<Emails />} />
          <Route path="proxy" element={<Proxy />} />
          <Route path="files" element={<Files />} />
          <Route path="whitelist" element={<Whitelist />} />
          <Route path="userFiles" element={<UserFile />} />
        </Route>

        {/* 捕获所有未匹配的路由，重定向到登录页面 */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
